import { connect } from 'react-redux';
import compose from 'recompose/compose';

import TimeTrackReport from './components/timeTrackReport';
import { canLoadReport, getActiveBarbersFilterIds } from '../selectors';
import withDateToString from '../../../common/hoc/withDateToString';

const mapStateToProps = state => ({
  canInstantDownloadCsv: canLoadReport(state),
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
  timezone: state.auth.timezone,
  barberFilter: getActiveBarbersFilterIds(state),
});

export default compose(
  connect(mapStateToProps),
  withDateToString,
)(TimeTrackReport);
